export default __webpack_public_path__ + "ui/assets/img/attention-16.svg";